import { Injectable } from '@angular/core';

import { AdType } from '@src/app/enum/ad-type.enum';
import { PackageName } from '@src/app/enum/package-nane.enum';
import { TokenStore } from './authentication/token.store';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class AdsControlService {

  private readonly adsListBasic = [
    { type: AdType.Fuel },
    { type: AdType.Tech5G },
    { type: AdType.NewOrders },
    { type: AdType.FilesDDD },
    { type: AdType.Serwis },
  ];

  private readonly adsListBussiness = [
    { type: AdType.Tech5gBussiness },
    { type: AdType.VehicelesAfter2025 },
    { type: AdType.End2gNew5g },
  ];

  public currentAdVisible: { type: AdType };

  private readonly STORAGE_KEY = 'lastAdIndex';
  private readonly tokenStore = new TokenStore();

  private get adsList(): any[] {
    return this.tokenStore.token?.packageName === PackageName.Business ? this.adsListBussiness : this.adsListBasic;
  }

  constructor(
    private langaugeService: LanguageService,
  ) {
    if (this.langaugeService.isPolishLanguage) {
      this.showNextAd();
    }
  }

  private getLastAdIndex(): number | null {
    const index = localStorage.getItem(this.STORAGE_KEY);
    return index !== null ? Number(index) : null;
  }

  private setLastAdIndex(index: number) {
    localStorage.setItem(this.STORAGE_KEY, index.toString());
  }

  private showAd(index: number): void {
    this.setLastAdIndex(index);
    this.currentAdVisible = this.adsList[index];
  }

  private showNextAd(): void {
    let lastIndex = this.getLastAdIndex();

    if (lastIndex === null || lastIndex >= this.adsList.length - 1) {
      lastIndex = 0;
    } else {
      lastIndex++;
    }

    this.showAd(lastIndex);
  }

}
